@if(amount){<span [ngClass]="{ 'color-red': amount && amount < 0}"> {{ amount | number: "1.2-2" | noComma }}%</span>}